import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellCenterWrapper } from '../../styles';
import { Button } from '../../../../../../../components';
import { BLACKLIST_DOMAINS } from '../../../enums';
import { TableProps } from '../../types';

export const Delete = ({
  val, row, setOpenModal, setModalInfo, isReadOnly,
}: TableProps) => (
  <CellCenterWrapper>
    <Button
      onClick={() => {
        setOpenModal();
        setModalInfo({
          id: row.id,
          domain: row.domain,
          type: BLACKLIST_DOMAINS.MODAL.TYPES.REMOVE,
        });
      }}
      theme="quaternary"
      disabled={isReadOnly}
    >
      <FontAwesomeIcon icon={val} />
    </Button>
  </CellCenterWrapper>
);
